export default "__VITE_ASSET__BlHrE76H__"